import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Experiencedapp(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Developing Mobile Apps with a Custom Approach in KSA</h2>
            <p className="main_para">
              Having a customized approach for your business mobile app
              development in KSA is always a great idea. It enables you to
              unleash the true potential of exceptional ideas based on your
              specific business needs. We have proven experience in custom
              mobile app development in KSA that satisfies both business and
              user ends.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Get Started
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <StaticImage
              src="../../../images/locationgcc/sa/mobileapps.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={909}
              height={761}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Experiencedapp;
